(() => {
const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const json = el => { try { return el ? JSON.parse(el.textContent) : null; } catch { return null; } };

const init = () => {
  const copy = json($('[data-lumnue-copy]')) || {};

  $$('.mobile-menu nav a').forEach(a =>
    a.addEventListener('click', () => a.closest('details').removeAttribute('open')));

  const lightbox = $('[data-lightbox]');
  const fit = $('[data-fit-dialog]');
  const openZoom = src => {
    if (!lightbox || !src) return;
    $('[data-zoom-image]', lightbox).src = src;
    lightbox.showModal();
  };
  $$('[data-open-fit]').forEach(b => b.addEventListener('click', () => fit?.showModal()));
  $$('[data-close-dialog]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
  $$('dialog').forEach(d => d.addEventListener('click', e => {
    if (e.target !== d) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  }));

  const main = $('[data-gallery-main]');
  const mainImg = main && $('img', main);
  const tag = $('[data-gallery-tag]');
  const setSlide = btn => {
    if (!mainImg || !btn) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = btn.dataset.full;
    mainImg.alt = btn.dataset.alt || '';
    main.dataset.zoom = btn.dataset.zoom || btn.dataset.full;
    if (tag) { tag.textContent = btn.dataset.tag || ''; tag.hidden = !btn.dataset.tag; }
    $$('[data-thumb]').forEach(t => t.setAttribute('aria-current', String(t === btn)));
  };
  $$('[data-thumb]').forEach(t => t.addEventListener('click', () => setSlide(t)));
  main?.addEventListener('click', () => openZoom(main.dataset.zoom));

  const colorPhotos = json($('[data-color-photos]')) || {};
  const showColor = color => {
    const photo = colorPhotos[color];
    const first = $('[data-thumb]');
    if (!photo || !first) return;
    first.dataset.full = photo.src;
    first.dataset.zoom = photo.zoom || photo.src;
    first.dataset.tag = color;
    first.dataset.alt = `${copy.product || ''} in ${color}`.trim();
    const ti = $('img', first);
    if (ti) { ti.removeAttribute('srcset'); ti.src = photo.src; ti.alt = first.dataset.alt; }
    setSlide(first);
  };

  const chooser = $('[data-chooser]');
  if (chooser) {
    const verdict = $('[data-verdict]', chooser);
    const empty = $('[data-verdict-empty]', chooser);
    const score = () => {
      const picked = ['mattress', 'position', 'pillows']
        .map(n => $(`input[name="q-${n}"]:checked`, chooser));
      if (picked.some(p => !p)) return null;
      const total = picked.reduce((s, p) => s + Number(p.dataset.score || 0), 0);
      const firm = $('input[name="q-mattress"]:checked', chooser).value === 'firm';
      return total > 0 || (total === 0 && firm) ? 'tall' : 'standard';
    };
    const render = () => {
      const r = score();
      if (!r) return;
      const data = json($('[data-chooser-copy]')) || {};
      const v = data[r] || {};
      $('[data-verdict-k]', verdict).textContent = v.name || '';
      $('[data-verdict-copy]', verdict).textContent = v.why || '';
      verdict.classList.add('on');
      empty?.classList.add('off');
      const pick = $('[data-verdict-pick]', verdict);
      if (pick) pick.dataset.size = v.option || '';
    };
    $$('input[name^="q-"]', chooser).forEach(i => i.addEventListener('change', render));
    $('[data-verdict-pick]', chooser)?.addEventListener('click', e => {
      const want = e.currentTarget.dataset.size;
      const hit = $$('[data-option-index]').find(i => i.value === want);
      if (hit) { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
      $('#pillow-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  const form = $('[data-product-form]');
  if (!form) { showColor($('[data-color-input]:checked')?.value || copy.defaultColor); return; }

  const variants = json($('[data-variants]', form)) || [];
  const select = $('[data-variant-select]', form);
  const button = $('[data-add-button]', form);
  const error  = $('[data-form-error]', form);
  const qtyEl  = $('input[name="quantity"]', form);   // select by name: [data-qty] also matches the bundle labels
  // Held as an array rather than re-queried inside the form, because with Kaching on
  // the option fieldsets are moved out of the form to sit above its bundle picker.
  const inputs = $$('[data-option-index]', form);
  const ready  = button.dataset.ready === 'true';

  // Kaching Bundles (as an app block in the form, or injected by its app embed) owns
  // quantity and bundle pricing. The theme's own picker steps aside so there are never
  // two bundle choosers, and the button stops printing a one pillow price over a deal.
  const appBundles = !!$('[data-app-slot]', form) || window.kachingBundlesEnabled === true;
  if (appBundles) {
    $$('.bundles', form).forEach(b => {
      b.style.display = 'none';
      $$('input', b).forEach(i => { i.disabled = true; });
      const label = b.previousElementSibling;
      if (label?.matches('.opt-label')) label.style.display = 'none';
    });
    // The embed injects its picker just above the form, which would ask how many before
    // which height. Move the Height and Colour choices up so the order reads height,
    // colour, bundle, add to cart. The embed can arrive after this script runs.
    const fields = $$('.product-option', form);
    const place = () => {
      const kb = $('kaching-bundle');
      if (!kb) return false;
      if (kb.previousElementSibling !== fields[fields.length - 1]) fields.forEach(f => kb.before(f));
      return true;
    };
    if (!place()) {
      const mo = new MutationObserver(() => { if (place()) mo.disconnect(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 15000);
    }
  }

  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: copy.currency || 'USD' }).format(n / 100);

  const linked = variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant'));
  if (linked) inputs.forEach(i => { i.checked = linked.options[Number(i.dataset.optionIndex)] === i.value; });
  if (inputs.length || !ready) select.hidden = true;

  const priceBundles = unit => $$('[data-bundle]', form).forEach(b => {
    const qty = Number(b.dataset.qty || 1);
    const off = Number(b.dataset.off || 0);
    const full = unit * qty;
    // Shopify floors the percentage discount per unit, so mirror that exactly or the
    // price on the button will not match what the cart charges.
    const now  = (unit - Math.floor(unit * off)) * qty;
    const nowEl  = $('[data-bundle-now]', b);
    const saveEl = $('[data-bundle-save]', b);
    if (nowEl) nowEl.textContent = money(now);
    if (saveEl) {
      const diff = full - now;
      saveEl.textContent = diff > 0 ? `${copy.save || 'Save'} ${money(diff)}` : '';
      saveEl.hidden = diff <= 0;
    }
    b.dataset.total = String(now);
  });

  const update = () => {
    const checked = inputs.filter(i => i.checked);
    const selected = inputs.length
      ? variants.find(v => checked.length === v.options.length &&
          checked.every(c => v.options[Number(c.dataset.optionIndex)] === c.value))
      : variants.find(v => String(v.id) === select.value);

    if (selected && select.value !== String(selected.id)) {
      select.value = String(selected.id);
      // Kaching follows the variant through the form's id field. The chips no longer sit
      // inside the form when it is on, so announce the change on the field itself. The
      // value is already set, so the update this triggers does not dispatch again.
      if (appBundles) select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const bundleInput = appBundles ? null : $('input[name="bundle"]:checked', form);
    const bundleEl = bundleInput ? bundleInput.closest('[data-bundle]') : null;
    if (!appBundles) {
      const qty = Number(bundleEl?.dataset.qty || 1);
      if (qtyEl) qtyEl.value = String(qty);
    }

    if (selected) priceBundles(selected.price);
    const total = Number(bundleEl?.dataset.total || selected?.price || 0);

    button.disabled = !ready || !selected?.available;
    const label = !ready ? copy.coming : !selected?.available ? copy.sold : copy.add;
    button.textContent = ready && selected?.available && !appBundles ? `${label} — ${money(total)}` : label;

    showColor(inputs.find(i => i.checked && i.hasAttribute('data-color-input'))?.value || copy.defaultColor);

    if (selected) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(selected.id));
      history.replaceState({}, '', url);
    }
  };

  inputs.forEach(i => i.addEventListener('change', update));
  $$('input[name="bundle"]', form).forEach(i => i.addEventListener('change', update));
  select.addEventListener('change', update);
  update();

  form.addEventListener('submit', async e => {
    if (button.disabled) return;
    e.preventDefault();
    error.textContent = '';
    button.disabled = true;
    button.textContent = copy.adding;
    try {
      const res = await fetch(copy.root + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const out = await res.json();
      if (!res.ok) throw new Error(out.description || copy.error);
      const notice = $('[data-cart-notice]');
      if (notice) notice.hidden = false;
      const cr = await fetch(copy.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (cr.ok) {
        const cart = await cr.json();
        $$('[data-cart-count]').forEach(n => { n.textContent = cart.item_count; });
      }
    } catch (err) {
      error.textContent = err.message || copy.error;
    } finally {
      update();
    }
  });
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
else init();
})();
